//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "Stats",
  data () {
    return {
    }
  },
  computed: {
      playerplayed() {
        return this.$store.getters.getPlayerPlayed
      },
      questionCount() {
        return this.$store.getters.getQuestion1Count + this.$store.getters.getQuestion2Count + this.$store.getters.getQuestion3Count
      },
      legendsCount() {
        return this.$store.getters.getLegendsCount
      },
      krampenCount() {
        return this.$store.getters.getKrampenCount
      }
  },
  watch: {
    playerplayed(newValue/*, oldData*/) {
      console.log(newValue)
    },
    questionCount: function() {
      console.log(this.$store.getters.getQuestion1Count + this.$store.getters.getQuestion2Count + this.$store.getters.getQuestion3Count)
    },
    legendsCount: function() {
      console.log(this.$store.getters.getLegendsCount)
    },
    krampenCount: function() {
      console.log(this.$store.getters.getKrampenCount)
    },
  },
  methods: {
    startGame: function() {
      this.$router.replace('/game')
    }
  }
}
